import { useNodes } from "@xyflow/react"

export const EmptyState = () => {
	const nodes = useNodes()

	if (nodes.length > 0) {
		return null
	}

	return (
		<div className="absolute inset-0 flex items-center justify-center pointer-events-none z-10">
			<div className="text-center space-y-3 max-w-md">
				<div className="text-3xl mb-2 opacity-60">⚡</div>
				<h2 className="text-base font-medium text-foreground">
					Start creating
				</h2>
				<p className="text-sm text-muted-foreground">
					Press{" "}
					<kbd className="px-1.5 py-0.5 rounded border bg-muted/50 text-xs font-mono">
						⌘K
					</kbd>{" "}
					or double-click the canvas to begin
				</p>
				<p className="text-xs text-muted-foreground/70 mt-3 font-mono">
					Try: &quot;sum of edges&quot; or &quot;create point&quot;
				</p>
			</div>
		</div>
	)
}
